import React from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';

import { selectSportHistoryLocale } from 'features/sportHistory/redux/selectors';

import './BetItem.scss';

const b = block('bet-item');

const BetItem = ({ item }) => {
  const locale = useSelector(selectSportHistoryLocale);
  return (
    <div
      className={b({
        status: item.status,
      })}>
      <div className={b('item')}>
        <div className={b('label')}>{locale.event}</div>
        <div className={b('value')}>{item.eventName}</div>
      </div>
      <div className={b('item')}>
        <div className={b('label')}>{locale.eventType.title}</div>
        <div className={b('value')}>{item.isLive ? locale.eventType.live : locale.eventType.offline}</div>
      </div>
      <div className={b('item')}>
        <div className={b('label')}>{locale.region}</div>
        <div className={b('value')}>{item.countryName}</div>
      </div>
      <div className={b('item')}>
        <div className={b('label')}>{locale.tournament}</div>
        <div className={b('value')}>{item.tournamentName}</div>
      </div>
      <div className={b('item')}>
        <div className={b('label')}>{locale.sport}</div>
        <div className={b('value')}>{item.sportName}</div>
      </div>
      <div className={b('item')}>
        <div className={b('label')}>{locale.outcome}</div>
        <div className={b('value')}>{item.outcome}</div>
      </div>
      <div className={b('item')}>
        <div className={b('label')}>{locale.coef}</div>
        <div className={b('value')}>{item.coef}</div>
      </div>
      <div className={b('item')}>
        <div className={b('label')}>{locale.score}</div>
        <div className={b('value')}>{item.score}</div>
      </div>
      <div className={b('item')}>
        <div className={b('label')}>{locale.status.title}</div>
        <div
          className={b('value', {
            status: item.status,
          })}>
          {locale.status?.[item.status] ?? item.status}
        </div>
      </div>
    </div>
  );
};

export default BetItem;
